/*
 * MaintenanceMessages.js
 *
 * Event handlers for managing admin maintenance messages.
 */

export function addMaintenanceMessageHandlers() {
  // Duplicate maintenance message
  $('#body_section_center')
    .off('click.DuplicateMessage')
    .on('click.DuplicateMessage', '.DuplicateMessage', function (event) {
      event.preventDefault()
      $.meDialog.yesno('Confirm', 'Duplicate this message?', () => {
        $.post(
          `/account/admin_maintenance_message.duplicate_message/-/${$(
            this
          ).data('mm-id')}`
        )
          .done(() => {
            $('table.messages_table').trigger('server_side_table_refresh')
            $.meDialog.topMessage('Message duplicated.', 4000, 'success')
          })
          .fail(jqXHR => {
            $.meDialog.topMessage(jqXHR.responseJSON.error, 4000, 'danger')
          })
      })
    })

  // Disable maintenance message
  $('#body_section_center')
    .off('click.DisableMessage')
    .on('click.DisableMessage', '.DisableMessage', function (event) {
      event.preventDefault()
      console.log('Clicked .DisableMessage')
      $.meDialog.yesno('Confirm', 'Disable this message?', () => {
        $.post(
          `/account/admin_maintenance_message.disable_message/-/${$(this).data(
            'mm-id'
          )}`
        )
          .done(data => {
            console.log(data)
            $('table.messages_table').trigger('server_side_table_refresh')
            $.meDialog.topMessage('Message disabled.', 4000, 'success')
          })
          .fail(jqXHR => {
            $.meDialog.topMessage(jqXHR.responseJSON.error, 4000, 'danger')
          })
      })
    })

  // Delete maintenance message
  $('#body_section_center')
    .off('click.DeleteMessage')
    .on('click.DeleteMessage', '.DeleteMessage', function (event) {
      event.preventDefault()
      console.log('Clicked .DeleteMessage')
      $.meDialog.yesno('Confirm', 'Delete this message?', () => {
        $.post(
          `/account/admin_maintenance_message.delete_message/-/${$(this).data(
            'mm-id'
          )}`
        )
          .done(data => {
            console.log(data)
            $('table.messages_table').trigger('server_side_table_refresh')
            $.meDialog.topMessage('Message deleted.', 4000, 'success')
          })
          .fail(jqXHR => {
            $.meDialog.topMessage(jqXHR.responseJSON.error, 4000, 'danger')
          })
      })
    })
}
